import React from 'react';
import { useAuth } from '../context/AuthContext';
import { MessageCircle, BookOpen, User, Lightbulb, LogOut, Sparkles, Crown, CreditCard, BookOpenCheck, LogIn, Scale, UtensilsCrossed, Camera, Trophy } from 'lucide-react';

const Sidebar = ({ activePage, setActivePage, onAuthClick, onUpgradeClick }) => {
  const { user, profile, logout, isAuthenticated, getSubscriptionStatus } = useAuth();

  const subscriptionStatus = getSubscriptionStatus();
  const isPro = subscriptionStatus === 'pro' || subscriptionStatus === 'trial';

  const navItems = [
    { id: 'chat', icon: MessageCircle, label: 'Louis' },
    { id: 'journal', icon: BookOpenCheck, label: 'Journal', proOnly: true },
    { id: 'weight', icon: Scale, label: 'Poids', proOnly: true },
    { id: 'mealplan', icon: UtensilsCrossed, label: 'Plans', proOnly: true },
    { id: 'scanner', icon: Camera, label: 'Scanner', proOnly: true },
    { id: 'challenges', icon: Trophy, label: 'Défis', proOnly: true },
    { id: 'recipes', icon: BookOpen, label: 'Recettes' },
    { id: 'tips', icon: Lightbulb, label: 'Conseils' },
    { id: 'profile', icon: User, label: 'Profil' },
    { id: 'subscription', icon: CreditCard, label: 'Abonnement' }
  ];
  
  const getBadgeClass = () => {
    switch(subscriptionStatus) {
      case 'pro': return 'user-badge';
      case 'trial': return 'user-badge trial';
      default: return 'user-badge free';
    }
  };

  const getBadgeText = () => {
    switch(subscriptionStatus) {
      case 'pro': return 'Pro';
      case 'trial': return 'Essai';
      default: return 'Free';
    }
  };

  const handleNavClick = (item) => {
    // Toujours naviguer vers la page - le ProGate sur chaque page gère l'affichage
    setActivePage(item.id);
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <img src="./robot-icon.svg" alt="MonCoach" className="logo-icon-img" />
          <span className="logo-text">MonCoach</span>
        </div>
        <span className="logo-badge">Nutrition</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${activePage === item.id ? 'active' : ''}`}
            onClick={() => handleNavClick(item)}
          >
            <item.icon size={20} />
            <span>{item.label}</span>
            {item.proOnly && <span className="nav-pro-badge">Pro</span>}
          </button>
        ))}
      </nav>

      {/* Bouton Passer Pro pour les free/trial */}
      {isAuthenticated && subscriptionStatus !== 'pro' && subscriptionStatus !== 'trial' && (
        <div className="upgrade-banner">
          <button className="upgrade-sidebar-btn" onClick={onUpgradeClick}>
            <Crown size={18} />
            <span>Passer Pro</span>
          </button>
        </div>
      )}

      <div className="sidebar-footer">
        {isAuthenticated ? (
          <div className="user-card">
            <div className="user-avatar">
              {profile?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || '?'}
            </div>
            <div className="user-info">
              <span className="user-name">{profile?.name || 'Utilisateur'}</span>
              <span className="user-email">{user?.email}</span>
            </div>
            <span className={getBadgeClass()}>{getBadgeText()}</span>
            <button onClick={logout} className="logout-btn" title="Déconnexion">
              <LogOut size={18} />
            </button>
          </div>
        ) : (
          <div className="auth-buttons">
            <button className="login-cta" onClick={onAuthClick}>
              <Sparkles size={18} />
              <span>S'inscrire gratuitement</span>
            </button>
            <button className="login-secondary" onClick={() => onAuthClick('login')}>
              <LogIn size={18} />
              <span>Connexion</span>
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
